import "./welcome-back.css"
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import axios from "axios";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import {setAppData} from "../../../redux/register_store";
import {setPersonalData} from "../../../redux/personal_store";
import {setLoginInfo} from "../../../redux/login_store";
import {setFinancialInfo} from "../../../redux/financial_store";
import {setAffiliationField} from "../../../redux/affiliation_store";
import {setExpInfoData} from "../../../redux/experience_store";
import {setConditionInfo} from "../../../redux/conditions_store";
import {setCustodialData} from "../../../redux/custodial_acc_store";
import {setOwnerData} from "../../../redux/owner_info_store";
import {setAuthInfo} from "../../../redux/auth_singer_store";
import {setVerifyInfo} from "../../../redux/verify_password_store";

function WelcomeBackInfo({
                             response,
                             setAppData,
                             appData,
                             setPersonalData,
                             setLoginInfo,
                             setFinancialInfo,
                             setAffiliationField,
                             setExpInfoData,
                             setConditionInfo,
                             setCustodialData,
                             setOwnerData,
                             setAuthInfo,
                             setVerifyInfo
                         }) {

    const {t} = useTranslation()
    const navigate = useNavigate()
    const [accountStates, setAccountStates] = useState([]);

    useEffect(() => {
        if (response && response.length) {
            const initialAccountStates = response.map(() => ({
                successAlert: false,
                showAlert: false,
            }));
            setAccountStates(initialAccountStates);
        }
    }, [response]);

    const handleDelete = async (index) => {
        try {
            const currentAccount = response[index];

            if (!currentAccount || !currentAccount.AppID) return;

            const URL = `${process.env.REACT_APP_API_URL}/api/accounts/deleteApplication/` + currentAccount.AppID;
            const {data} = await axios.delete(URL);

            if (data) {
                setAccountStates((prevStates) => {
                    const newStates = [...prevStates];
                    newStates[index].successAlert = true;
                    return newStates;
                });

                localStorage.clear();
                setAppData({
                    account_type: 'individual',
                    sub_account_type: '',
                    email: '',
                    password: '',
                    confirm_password: '',
                    hear_about_us: '',
                    citizenship_status: '',
                    app_id: '',
                    specialtyAccountType: 'C',
                    country_of_birth: '',
                    country_of_residence: '',
                    country_of_citizenship: '',
                    clientIP: ''
                })
                setTimeout(() => {
                    navigate("/");
                }, 1500);
            }
        } catch (error) {
            console.error("Error deleting application:", error);

            setAccountStates((prevStates) => {
                const newStates = [...prevStates];
                newStates[index].showAlert = true;
                return newStates;
            });
        }
    };

    const formatDateInputAPI = (dateString) => {
        return dateString.replace(/\D/g, '').replace(/(\d{4})(\d{2})(\d{2})/, '$2/$3/$1')
    }

    const getAcc = async (index) => {
        if (!response || !response[index] || !response[index].AppID) return;

        const URL = `${process.env.REACT_APP_API_URL}/api/accounts/` + response[index].AppID;
        try {
            const {data} = await axios.put(URL);

            if (data) {
                setAppData({
                    account_type: data.AccountType,
                    sub_account_type: data.SubAccountType,
                    email: data.Email,
                    password: '',
                    confirm_password: '',
                    hear_about_us: data.Source,
                    citizenship_status: data.Citizenship,
                    app_id: data.AppID,
                    specialtyAccountType: data.CorpType,
                    country_of_birth: data.CountryBirth,
                    country_of_residence: data.CountryResidence,
                    country_of_citizenship: data.CountryCitizenship
                })

                setPersonalData({
                    title: data.Title,
                    firstName: data.FirstName,
                    lastName: data.LastName,
                    middleName: data.MiddleInitial,
                    birth: formatDateInputAPI(data.DOB),
                    ssn: data.TaxID,
                    confirmSsn: data.TaxID,
                    phone: data.MobilePhone,
                    maritalStatus: data.MaritalStatus,
                    idenType: data.GovtIDType,
                    idenNumber: data.GovtID,
                    issueDate: formatDateInputAPI(data.GovtIDIssueDate),
                    expDate: formatDateInputAPI(data.GovtIDExpDate),
                    permAddress: data.Paddress1,
                    address2: data.Paddress2,
                    city: data.Pcity,
                    country: data.Pcountry,
                    zipCode: data.Pzip,
                    state: data.Pstate,
                    mailingCountry: data.Mcountry,
                    mailingAddress: data.Maddress1,
                    mailingAddress2: data.Maddress2,
                    mailingCity: data.Mcity,
                    mailingZipCode: data.Mzip,
                    mailingState: data.Mstate,
                    trustName: data.TrustName,
                    trustCountry: data.TrustCountry,
                    mailingDiff: data.MailingDiff
                });

                setFinancialInfo({
                    emplStatus: data.EmployStatus,
                    sourceOfIncome: data.PrimaryIncomeSrc,
                    sourceOfWealth: data.SourceWealth,
                    annualIncome: data.AnnualIncome,
                    assets: data.LiquidAssets,
                    netWorth: data.NetWorth,
                    schoolName: data.StudenSchoolName,
                    occupation: data.Occupation,
                    companyName: data.CompanyName,
                    businessState: data.BusinessState,
                    businessAddress: data.BusinessAddress,
                    city: data.BusinessCity,
                    zipCode: data.BusinessZip,
                    countryName: data.BusinessCountry,
                    businessPhone: data.BusinessPhone,
                    soldBusinessName: data.SoldBusinessName,
                    soldAmount: data.SoldAmount,
                    soldBusinessDate: formatDateInputAPI(data.SoldBusinessDate)
                })

                setAffiliationField({
                        questions: [
                            {
                                id: 1,
                                name: data.AffiliationMember,
                                text: 'affiliation.are_member',
                                selected: false
                            },
                            {
                                id: 2,
                                name: data.AffiliationBroker,
                                text: 'affiliation.NFA_or_CFTC',
                                selected: false
                            },
                            {
                                id: 3,
                                name: data.AffiliationForShellBank,
                                text: 'affiliation.foreign_shell',
                                selected: false
                            },
                            {
                                id: 4,
                                name: data.AffiliationShellBank,
                                text: 'affiliation.owner_affiliated',
                                selected: false
                            },
                            {
                                id: 5,
                                name: data.AffiliationShellBankService,
                                text: 'affiliation.owner_offer',
                                selected: false
                            },
                            {
                                id: 6,
                                name: data.AffiliationBankrupt,
                                text: 'affiliation.bankruptcy_proceeding',
                                selected: false
                            },
                            {
                                id: 7,
                                name: data.AffiliationLegal,
                                text: 'affiliation.commodity_account',
                                selected: false
                            },
                            {
                                id: 8,
                                name: data.AffiliationUnpaid,
                                text: 'affiliation.commodity_firm',
                                selected: false
                            },
                            {
                                id: 9,
                                name: data.AffiliationOtherFunds,
                                text: 'affiliation.business_with_you',
                                selected: false
                            },
                            {
                                id: 10,
                                name: data.AffiliationFFI,
                                text: 'affiliation.financial_institution',
                                selected: false
                            },
                            {
                                id: 11,
                                name: data.AffiliationPoliOfficial,
                                text: 'affiliation.close_associate',
                                selected: false
                            }
                        ],
                        name: '',
                        process: '',
                        position: '',
                        affPerson: '',
                        companyName: '',
                        organizations: '',
                        memberPosition: '',
                        memberAffPerson: '',
                        memberCompanyName: ''
                    }
                )
                setExpInfoData({
                    stockYear: data.StockYearsExp,
                    stockAverageSize: data.StockAvgSize,
                    stockAverageNumber: data.StockAvgTrans,
                    optionYear: data.OptionYears,
                    optionAverageSize: data.OptionSize,
                    optionAverageNumber: data.OptionAvgTrans,
                    invest_obj: data.InvestmentObj
                })
                setConditionInfo({
                    customer: data.AgreeCust,
                    margin: data.AgreeMargin,
                    option: data.AgreeOption,
                    taxPlayer: data.ExemptW9,
                    clear: data.AddressVerified,
                    agreew8: data.AgreeW8BEN,
                    disclosure: data.OwnerDisclosure,
                    privacy: data.AgreePrivacy,
                    agreeConfirm: data.AgreeEConfirm,
                    agreeEstatement: data.AgreeEstatement,
                    agreeProxy: data.AgreeEProxy,
                    agreePros: data.AgreeEProspectus,
                    agreeEtax: data.AgreeETax,
                })
                setLoginInfo({
                    email: '',
                    password: ''
                })
                setCustodialData({
                    custodial_first_name: data.CustodialFirstName,
                    custodial_last_name: data.CustodialLastName,
                    custodial_middle_name: data.CustodialMiddleInitial,
                    custodial_ssn: data.CustodialTaxID,
                    custodial_birth: formatDateInputAPI(data.CustodialDOB),
                    custodial_type: data.CustodialType
                })
                setOwnerData({
                    joint_title: data.JointTitle,
                    joint_first_name: data.JointFirstName,
                    joint_last_name: data.JointLastName,
                    joint_middle_name: data.JointMiddleInitial,
                    joint_birth: formatDateInputAPI(data.JointDOB),
                    joint_citizenship_status: data.JointCitizenship,
                    joint_ssn: data.JointTaxID,
                    joint_confirm_ssn: data.JointTaxID,
                    joint_iden_type: data.JointGovtIDType,
                    joint_iden_number: data.JointGovtID,
                    joint_issue_date: formatDateInputAPI(data.JointGovtIDIssueDate),
                    joint_exp_date: formatDateInputAPI(data.GovtIDExpDate),
                    joint_spouse: data.JointIsSpouse,
                    joint_same_add: data.JointIsSameAdd,
                    joint_mobile_phone: data.JointMobilePhone,
                    joint_home_phone: data.JointHomePhone,
                    joint_emp_status: data.JointEmployStatus,
                    joint_member: data.JointMemberOther,
                    joint_indicate1: data.JontInterestMainOwner,
                    joint_indicate2: data.JointInterestJointOwner,
                    joint_occupation: data.JointOccupation,
                    joint_company_name: data.JointCompanyName,
                    joint_address: data.JointBusinessAddress,
                    joint_city: data.JointBusinessCity,
                    joint_business_country: data.JointBusinessCountry,
                    joint_business_state: data.JointBusinessState,
                    joint_zip_code: data.JointBusinessZip,
                    joint_school_name: data.JointStudentSchoolName,
                    joint_no_address: data.JointPaddress1,
                    joint_no_address2: data.JointPaddress2,
                    joint_no_city: data.JointPCity,
                    joint_no_country: data.JointPcountry,
                    joint_no_zip_code: data.JointPzip,
                    country_of_birth: data.JointCountryBirth,
                    country_of_residence: data.JointCountryResidence,
                    country_of_citizenship: data.JointCountryCitizenship,
                    joint_no_state: data.JointPstate
                })
                setAuthInfo([{
                    checked: false,
                    auth_title: data.JointTitle,
                    auth_first_name: data.JointFirstName,
                    auth_middle_name: data.JointMiddleInitial,
                    auth_last_name: data.JointLastName,
                    auth_entity_role: data.EntityRole
                }])
                setVerifyInfo({
                    email: data.email,
                    new_password: data.password,
                    confirm_new_password: data.password_confirm,
                })
            }
        } catch (error) {
            console.error("Error fetching account information:", error);
        }
    };

    const accountAppId = async (index) => {
        getAcc(index).then(() => {
            if (response[index]) {
                const steps = response[index].Step;
                if (steps === 0) {
                    navigate('/')
                } else if (steps === 1) {
                    navigate('/personal');
                } else if (steps === 2) {
                    navigate('/financial');
                } else if (steps === 3) {
                    navigate('/affiliation');
                } else if (steps === 4) {
                    navigate('/account');
                } else if (steps === 31) {
                    navigate('/custodial-account');
                } else if (steps === 32 && appData.account_type === 'joint') {
                    navigate('/owner-info');
                } else if (steps === 32 && appData.account_type === 'speciality') {
                    navigate('/authorized-signers');
                } else if (steps === 7) {
                    navigate('/welcome-to');
                } else {
                    navigate('/conditions');
                }
            }
        })
    };

    return (
        <div>
            {response && response.length ?
                <div>
                    <Header/>
                    <div className="welcome_back">
                        <Logout/>
                        <div>
                            <p className="welcome_back_heading">{t('welcome_back.welcome_back')}</p>
                            <p className="resume_app">{t('welcome_back.click_below')}</p>
                            <p className="app_progress">{t('welcome_back.app_in_progress')}</p>
                        </div>
                        <div>
                            {
                                response.map((el, index) => (
                                    <div className="welcome_heading" key={index}>
                                        <p className="app_heading">{el.AccountType}</p>
                                        <p key={index} className="app_account_heading">
                                            {t('welcome_back.account')} ( {el.AppID} - {t('welcome_back.started')} {el.AddedDate} )
                                        </p>
                                        <p className="app_completed" key={index}>
                                            {t('welcome_back.completed')} {(el.Step === 32 || el.Step === 31) ? '5' : el.Step || '1'} {t('welcome_back.completed_of')}
                                        </p>
                                        <div className="welcome_back_btn">
                                            <button onClick={() => accountAppId(index)}
                                                    className="welcome_back_continue_btn"
                                                    type="submit">{t('next_btn')}</button>
                                            {el.Step !== 7 &&
                                                <button onClick={() => handleDelete(index)}
                                                        className="welcome_back_to_second_app_btn">{t('welcome_back.delete')}</button>
                                            }
                                        </div>
                                        {accountStates[index] && accountStates[index].showAlert && (
                                            <Alert variant="danger">
                                                Something went wrong!
                                            </Alert>
                                        )}

                                        {accountStates[index] && accountStates[index].successAlert && (
                                            <Alert variant="success" style={{marginTop: "10px", width: '50%'}}>
                                                Deleted successfully!
                                            </Alert>
                                        )}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <Footer/>
                </div>
                :

                <div>
                    404 Not Found
                </div>
            }
        </div>

    )
}

const mapStateToProps = (state) => ({
    appData: state.appData
});

const mapDispatchToProps = {
    setAppData,
    setLoginInfo,
    setPersonalData,
    setFinancialInfo,
    setAffiliationField,
    setExpInfoData,
    setConditionInfo,
    setCustodialData,
    setOwnerData,
    setAuthInfo,
    setVerifyInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeBackInfo);